const apiRoutes = {
    logout: () => `https://login.microsoftonline.com/common/wsfederation?wa=wsignout1.0`
};

export default apiRoutes;
